<template>
  <div
    class="navbar"
    :style="{ backgroundColor: type == 'screen' ? '' : '#00bfbf' }"
    :class="type == 'screen' ? 'navbar-screen' : ''"
  >
    <hamburger
      v-show="!type"
      id="hamburger-container"
      :is-active="sidebar.opened"
      class="hamburger-container"
      @toggleClick="toggleSideBar"
    />
    <!-- <img src="../../assets/images/background-top.png" alt=""> -->
    <div class="breadcrumb-container" v-if="!topNav && type != 'screen'">
      {{ consoleTitle ? consoleTitle : '智慧用电安全监测云平台' }}
    </div>
    <div class="right-menu">
      <!-- 跟项目 -->
      <!-- v-if="type != 'screen'"  :class="type == 'screen' ? 'item-screen' : ''"-->
      <div class="right-menu-item">
        <el-select v-model="projectIds" placeholder="请选择根项目" @change="projectChange">
          <el-option v-for="item in projectList" :key="item.id" :label="item.projectName" :value="item.id"> </el-option>
        </el-select>
      </div>
      <!-- <div class="right-menu-item item-screen" v-if="type == 'screen'">
      <el-select v-model="mapColor" placeholder="请选择地图主题颜色" @change="colorChange">
        <el-option v-for="item in colorList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
      </el-select>
    </div> -->
      <!-- 控制台 -->
      <!-- <div v-show="type == 'screen'" class="right-menu-item">
      <div class="console-box hover-effect" @click="goSystem">控制台</div>
    </div> -->
      <!-- 首页 -->
      <!-- <div v-show="!type && screenShow" class="right-menu-item">
        <i style="font-size: 21px" class="icon iconfont icon-shouye1 hover-effect" @click="goHome"></i>
      </div> -->
      <!-- 充电桩 -->
      <div v-if="accountLevel == '1'" class="right-menu-item">
        <div class="console-box2 hover-effect" @click="jump">充电桩系统</div>
      </div>
      <!-- 大屏 -->
      <div v-show="!type && screenShow" class="right-menu-item">
        <div class="console-box hover-effect" @click="goHome">大屏</div>
      </div>
      <!-- 全屏 -->
      <div class="right-menu-item">
        <screenfull id="screenfull" class="hover-effect" />
      </div>
      <!-- 声音 -->
      <div class="right-menu-item">
        <i
          style="font-size: 21px"
          class="icon iconfont hover-effect"
          :class="playback ? 'icon-shengyin' : 'icon-shengyinguanbi'"
        ></i>
      </div>
      <!-- 消息中心 -->
      <div class="right-menu-item" v-show="messShow">
        <span class="bottom-line" ref="line"></span>
        <el-badge
          slot="reference"
          :value="unreadCount"
          class="item"
          :hidden="unreadCount == 0"
          :class="flicker ? 'flash' : ''"
          :max="99"
        >
          <i
            class="icon iconfont icon-xiaoxi hover-effect"
            @click="messageCenterClick"
            @mouseenter="messagePushClick"
            @mouseleave="drawerClose"
          ></i>
        </el-badge>
      </div>
      <!-- 设置 -->
      <el-dropdown v-show="isShow" class="right-menu-item" trigger="click">
        <i style="font-size: 23px" class="icon iconfont icon-shezhi hover-effect" />
        <el-dropdown-menu slot="dropdown" class="user-dropdown">
          <router-link v-show="isShow1" to="/system/item">
            <el-dropdown-item> 项目管理 </el-dropdown-item>
          </router-link>
          <router-link v-show="isShow2" to="/system/role">
            <el-dropdown-item> 角色管理 </el-dropdown-item>
          </router-link>
          <router-link v-show="isShow3" to="/system/account">
            <el-dropdown-item> 账户管理 </el-dropdown-item>
          </router-link>
          <router-link v-show="isShow8" to="/system/neutral">
            <el-dropdown-item> 中性配置 </el-dropdown-item>
          </router-link>
          <router-link v-show="isShow4" to="/system/push">
            <el-dropdown-item> 推送设置 </el-dropdown-item>
          </router-link>
          <router-link v-show="isShow5" to="/system/log">
            <el-dropdown-item> 日志管理 </el-dropdown-item>
          </router-link>
          <router-link v-show="isShow6" to="/system/openPlatform">
            <el-dropdown-item> 开放平台 </el-dropdown-item>
          </router-link>
          <router-link v-show="isShow7" to="/system/opinionCollection">
            <el-dropdown-item> 意见收集栏 </el-dropdown-item>
          </router-link>
        </el-dropdown-menu>
      </el-dropdown>
      <!-- 帮助文档 -->
      <el-dropdown class="right-menu-item item-help" trigger="click">
        <!-- <div class="avatar-wrapper"> -->
        <i style="font-size: 21px" class="icon iconfont icon-bangzhu hover-effect"></i>
        <!-- </div> -->
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="helpClick">
            <span>PC端操作手册</span>
          </el-dropdown-item>
          <el-dropdown-item divided @click.native="helpAppClick">
            <span>App操作手册</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <!-- <div class="right-menu-item item-help">
      <i style="font-size: 21px" class="icon iconfont icon-bangzhu hover-effect" @click="helpClick"></i>
    </div> -->
      <!-- 竖杠 -->
      <div class="right-menu-item">
        <div class="item-bar"></div>
      </div>
      <!-- 头像 -->
      <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
        <div class="avatar-wrapper">
          <img :src="avatar" class="user-avatar" />
          <span>{{ name }}</span>
          <i class="el-icon-arrow-down" />
        </div>
        <el-dropdown-menu slot="dropdown">
          <router-link to="/accountCenter/baseData" v-show="baseShow">
            <el-dropdown-item>基本资料</el-dropdown-item>
          </router-link>
          <el-dropdown-item
            v-if="accountLevel == '3' || accountLevel == '4' || accountLevel == '5'"
            divided
            @click.native="suggest"
          >
            <span>反馈建议</span>
          </el-dropdown-item>
          <el-dropdown-item divided @click.native="logout">
            <span>退出登录</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <MessageNotify ref="child" :dialogVisible="dialogVisible" @close="close"></MessageNotify>
    <Notification></Notification>
    <!-- 消息面版 -->
    <div class="drawer" v-if="drawerVisible" @mouseenter="messagePushClick" @mouseleave="drawerClose">
      <el-drawer
        title="项目权限"
        :visible.sync="drawerVisible"
        :wrapperClosable="false"
        size="350px"
        :withHeader="false"
        :modal="false"
        :modal-append-to-body="false"
      >
        <div class="demo-drawer-content">
          <el-tabs
            v-model="activeName"
            :header-cell-style="{ 'border-right': '1px solid red' }"
            @tab-click="handleClick"
          >
            <el-tab-pane
              :key="item.name"
              v-for="item in activeTabs"
              :label="item.title"
              :name="item.name"
              v-loading="loading"
            >
              <span slot="label" v-if="item.name == '1'"
                >{{ item.title }}
                <el-badge
                  :value="unreadCount"
                  :hidden="unreadCount == 0"
                  class="item"
                  :max="99"
                  style="margin-left: 5px"
                ></el-badge>
              </span>
              <div v-if="activeName == '1'" class="drawer-top">
                <div class="top-l point-box" @click="allRead">全部标记已读</div>
                <div class="top-r point-box" @click="toMessage">更多</div>
              </div>
              <div v-show="activeName == '1'" class="drawer-content" v-for="item in alarmNewsList" :key="item.id">
                <div class="main-box">
                  <el-badge v-if="item.readed == 0" is-dot class="item"></el-badge>
                  <div class="main-content">
                    <div class="main-top">
                      {{ '【' + item.alarmTypeName + '】' }}
                      {{
                        item.alarmTypeName == '异常报警' || item.alarmTypeName == '火警'
                          ? ''
                          : (item.type == '1' ? '报警值' : '预警值') + item.alarmValue + '，'
                      }}{{ item.currentProjectName + '，' }}{{ item.pathName ? item.pathName + '，' : ''
                      }}{{ item.eqpName }}
                      <!-- 【温度报警】报警值90℃，山大校区改造项目 线路一 二楼配电室 9087588988590007， 信息楼#7，701室 -->
                    </div>
                    <div class="main-bottom">
                      <div style="color: #888888">{{ item.alarmTime }}</div>
                      <div style="color: #00bfbf" class="point-box" @click="lookDetail(item)">查看详情</div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-show="activeName == '2'" class="drawer-content" v-for="(item, index) in noticeList" :key="index">
                <div class="main-box">
                  <!-- <el-badge is-dot class="item"></el-badge> -->
                  <div class="main-content">
                    <div class="main-top">
                      {{ item.noticeTitle }}
                      <!-- {{ item.msgContent }} -->
                      <!-- 【温度报警】报警值90℃，山大校区改造项目 线路一 二楼配电室 9087588988590007， 信息楼#7，701室 -->
                    </div>
                    <div class="main-bottom">
                      <div style="color: #888888">{{ item.deliveryTime }}</div>
                      <div style="color: #00bfbf" class="point-box" @click="lookNoticeDetail(item)">查看详情</div>
                    </div>
                  </div>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-drawer>
    </div>
    <el-dialog
      class="orderDialog"
      title="反馈意见"
      :visible.sync="showDialog"
      width="30%"
      :close-on-click-modal="false"
    >
      <el-form :model="ruleForm" ref="ruleForm" label-width="170px" class="demo-form">
        <el-form-item label="对产品的意见或者建议：" prop="productProposal">
          <el-input
            type="textarea"
            placeholder="请输入处理描述"
            v-model="ruleForm.productProposal"
            :rows="3"
            maxlength="128"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="对平台的意见或者建议：" prop="platformProposal">
          <el-input
            type="textarea"
            placeholder="请输入处理描述"
            v-model="ruleForm.platformProposal"
            :rows="3"
            maxlength="128"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="submitForm">提交</el-button>
        <el-button size="small" @click="showDialog = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { mapState } from 'vuex'
// import { validatePsdReg } from '@/utils/validate'
import { getRootProjectByUser, saveUserProjectSelected, getRootByChildForUser } from '@/api/system/user'
import Hamburger from '@/components/Hamburger'
import Screenfull from '@/components/Screenfull'
import MessageNotify from '@/components/MessageNotify'
import {
  lastNotice,
  setRead,
  getAlarmNews,
  getNoticeList,
  allReadNews,
  getUnReadCount,
  alarmRead
} from '@/api/messageCenter/message'
import { feedbackOpinion } from '@/api/system/opinionCollection'
import MessagePush from '@/components/MessagePush'
import { getRouters } from '@/api/menu'
import store from '@/store'
import webscoket from '@/components/webscoket/webscoket'
import Notification from '@/components/Notification'
import { clearData, isEmpty } from '@/utils/validate'

export default {
  props: {
    type: [Number, String]
  },
  components: {
    Hamburger,
    Screenfull,
    MessageNotify,
    MessagePush,
    webscoket,
    Notification
  },
  data() {
    return {
      accountLevel: this.$store.state.user.accountLevel, //用户等级
      neutral: this.$store.state.user.neutral, //用户等级
      ruleForm: {
        productProposal: '',
        platformProposal: ''
      },
      showDialog: false,
      loading: false,
      alarmNewsList: [], //安全信息
      noticeList: [], //通知公告
      activeName: '1', //tab默认选中
      activeTabs: [
        {
          title: '安全信息',
          name: '1',
          content: 'Tab 1 content'
        },
        {
          title: '通知公告',
          name: '2',
          content: 'Tab 2 content'
        }
      ],
      projectIds: '', //跟项目
      projectList: [], //跟项目list
      imageUrl: store.getters.avatar,
      source: 0,
      fileList: [],
      dialogVisible: false, //消息通知弹框默认不显示
      drawerVisible: false, //消息推送
      messageDrawerTimeObj: null,
      screenShow: false,
      baseShow: false,
      messShow: false,
      isShow: false,
      isShow1: false,
      isShow2: false,
      isShow3: false,
      isShow4: false,
      isShow5: false,
      isShow6: false,
      isShow7: false,
      isShow8: true
      // mapColor: 'grey',
      // colorList: [{
      //     id: 'normal',
      //     name: '标准'
      //   },
      //   {
      //     id: 'dark',
      //     name: '幻影黑'
      //   },
      //   {
      //     id: 'light',
      //     name: '月光银'
      //   },
      //   {
      //     id: 'whitesmoke',
      //     name: '远山黛'
      //   },
      //   {
      //     id: 'fresh',
      //     name: '草色青'
      //   },
      //   {
      //     id: 'grey',
      //     name: '雅士灰(默认)'
      //   },
      //   // {
      //   //   id: 'graffiti',
      //   //   name: '涂鸦'
      //   // },
      //   {
      //     id: 'macaron',
      //     name: '马卡龙'
      //   },
      //   {
      //     id: 'blue',
      //     name: '靛青蓝'
      //   },
      //   {
      //     id: 'darkblue',
      //     name: '极夜蓝'
      //   },
      //   // {
      //   //   id: 'wine',
      //   //   name: '酱籽'
      //   // }
      // ]
    }
  },
  created() {
    getRootProjectByUser().then((res) => {
      this.projectList = res.data
      this.projectIds = this.$store.state.user.projectId
    })
    this.getRouter()
    this.messageClick() //通知公告
    if (this.neutral) {
      this.isShow8 = true
    } else {
      this.isShow8 = false
    }
    // console.log('navbar走了吗')
    // this.messagePushClick() //消息推送
  },
  computed: {
    ...mapGetters(['sidebar', 'avatar', 'device', 'name', 'userId', 'playback', 'flicker', 'unreadCount', 'projectId']),
    ...mapState({
      hasNeuTralConfig: (state) => state.nutral.hasNeuTralConfig,
      consoleTitle: (state) => state.nutral.consoleTitle,
      consoleLogo: (state) => state.nutral.consoleLogo,
      helpDocumentPc: (state) => state.nutral.helpDocumentPc,
      helpDocumentApp: (state) => state.nutral.helpDocumentApp
    }),
    setting: {
      get() {
        return this.$store.state.settings.showSettings
      },
      set(val) {
        this.$store.dispatch('settings/changeSetting', {
          key: 'showSettings',
          value: val
        })
      }
    },
    topNav: {
      get() {
        return this.$store.state.settings.topNav
      }
    }
  },
  watch: {
    avatar(val) {
      // console.log(val, 'val11111111111111')
    },
    playback(val) {
      // console.log(val, 'val11111111111')
    },
    flicker(val) {
      // console.log(val, 'val11111111111')
    },
    projectId(val) {
      this.projectIds = val
      // console.log(val, 'navbar里的id修改了')
    }
  },
  methods: {
    jump() {
      // let url = "https://kc.zhuowengroup.com/admin/index/login";
      let url = 'http://124.70.69.5:88/admin/index/login'
      window.open(`${url}`, '_blank')
    },
    // 反馈意见
    suggest() {
      clearData(this.ruleForm) //清空数据
      this.showDialog = true
    },
    // 提交建议
    submitForm() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (isEmpty(this.ruleForm.productProposal) && isEmpty(this.ruleForm.platformProposal)) {
            this.$message.error('两项必须输入一项')
            return false
          }
          feedbackOpinion(this.ruleForm).then((res) => {
            this.$message.success('保存成功')
            this.showDialog = false
          })
        } else {
          return false
        }
      })
    },
    //跟项目改变
    projectChange() {
      let params = {
        rootProjectId: this.projectIds
      }
      saveUserProjectSelected(params).then((res2) => {
        this.$store.commit('SET_PROJECT_ID', this.projectIds)
        // console.log('更新store', this.$store.state.user.projectId)
      })
      // this.goSystem()
    },
    // // 地图颜色变化
    // colorChange(val) {
    //   this.$emit('mapColors', val)
    // },
    // 跳转控制台
    goSystem() {
      getRouters().then((res) => {
        if (res.data.length > 0) {
          this.$router.push({
            path: res.data[1].path + '/' + res.data[1].children[0].path
          })
        }
      })
    },
    //帮助文档
    helpClick() {
      if (this.hasNeuTralConfig && this.helpDocumentPc) {
        window.open(this.helpDocumentPc, '_blank')
      } else {
        window.open('/卓文-用户操作手册.pdf', '_blank')
      }
    },
    helpAppClick() {
      if (this.hasNeuTralConfig && this.helpDocumentApp) {
        window.open(this.helpDocumentApp, '_blank')
      } else {
        window.open('/电卫士用户使用手册.pdf', '_blank')
      }
    },
    //跳转消息中心
    messageCenterClick() {
      this.$router.push({
        path: '/messageCenter'
      })
    },
    //跳转首页
    goHome() {
      this.$router.push({
        path: '/'
      })
    },
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    //消息弹框
    messageClick() {
      lastNotice().then((res) => {
        if (res.data !== null) {
          // console.log(res, 'res消息')
          this.noticeId = res.data.id
          this.$refs.child.messageShow()
          setTimeout(() => {
            this.dialogVisible = true
          }, 1000)
        } else {
          // console.log('111111111111没有消息')
        }
      })
    },

    // 关闭消息弹框
    close() {
      this.dialogVisible = false
      setRead(this.noticeId).then((res) => {
        this.messageClick()
      })
    },
    //鼠标进入消息推送
    messagePushClick(e) {
      this.unReadCount()
      //获取面板消息
      getAlarmNews().then((res) => {
        // console.log(res, 'res***')
        this.alarmNewsList = res.data
      })
      let params = {
        pageNum: 1,
        pageSize: 100,
        terrace: 'pc'
      }
      getNoticeList(params).then((res) => {
        this.noticeList = res.data.rows
      })

      this.$store.commit('SET_FLICKER', false)
      // console.log(this.$store.state.user.flicker, 'flicker修改了')
      if (e) {
        e.stopPropagation()
      }
      clearTimeout(this.messageDrawerTimeObj)
      this.drawerVisible = true
    },
    // 鼠标移出
    drawerClose() {
      clearTimeout(this.messageDrawerTimeObj)
      this.messageDrawerTimeObj = setTimeout(() => {
        this.drawerVisible = false
      }, 200)
    },
    //面板查看详情
    lookDetail(item) {
      // console.log(item, 'item9999999999')
      if (item.esId) {
        alarmRead(item.esId).then((res) => {})
        this.unReadCount()
      }
      this.drawerVisible = false
      if (this.$store.state.user.projectId != item.rootProjectId) {
        let params2 = {
          projectId: item.currentProjectId
        }
        getRootByChildForUser(params2).then((ele) => {
          let params = {
            rootProjectId: ele.data
          }
          saveUserProjectSelected(params).then((res) => {
            this.$store.commit('SET_PROJECT_ID', ele.data)
          })
          // console.log('更新store', this.$store.state.user.projectId)
        })
        // saveUserProjectSelected(params).then((res) => {
        //   this.$store.commit('SET_PROJECT_ID', item.rootProjectId)
        //   // console.log('更新store', this.$store.state.user.projectId)
        // })
      }
      this.$store.commit('SET_EQP_NUMBER', item.eqpNumber)
      // console.log(this.$store.state.user.eqpNumber, 'eqpNumber')
      if (item.type == '1') {
        sessionStorage.setItem('eqpNumber', item.eqpNumber)
        sessionStorage.setItem('majorType', item.majorType)
        this.$router.push({
          path: '/safeMonitor/alarmRecord'
          // query: {
          //   eqpNumber: item.eqpNumber,
          //   majorType: item.majorType
          // }
        })
      } else {
        sessionStorage.setItem('eqpNumber1', item.eqpNumber)
        sessionStorage.setItem('majorType1', item.majorType)
        this.$router.push({
          path: '/safeMonitor/awarningRecord'
          // query: {
          //   eqpNumber: item.eqpNumber,
          //   majorType: item.majorType
          // }
        })
      }
    },
    //面板消息全部已读
    allRead() {
      allReadNews().then((res) => {
        this.messagePushClick()
        this.unReadCount()
      })
    },
    //通知面板查看详情
    lookNoticeDetail(item) {
      this.drawerVisible = false
      sessionStorage.setItem('type', '2')
      this.$router.push({
        path: '/messageCenter'
        // query: {
        //   type: '2'
        // }
      })
    },
    //未读消息数更新
    unReadCount() {
      getUnReadCount().then((res) => {
        this.$store.commit('SET_UNREAD_COUNT', res.data)
        // console.log(this.$store.state.user.unreadCount, 'unreadCount修改了')
      })
    },
    // tab切换事件
    handleClick() {
      // this.queryClick()
    },
    //更多
    toMessage() {
      this.drawerVisible = false
      this.$router.push({
        path: '/messageCenter'
      })
    },
    //判断是否有路由
    getRouter() {
      getRouters().then((res) => {
        this.screenShow = false
        this.baseShow = false
        this.messShow = false
        this.isShow = false
        this.isShow1 = false
        this.isShow2 = false
        this.isShow3 = false
        this.isShow4 = false
        this.isShow5 = false
        this.isShow6 = false
        this.isShow7 = false
        res.data.forEach((item) => {
          if (item.name === 'system') {
            this.isShow = true
            item.children.forEach((item1) => {
              if (item1.name === 'item') {
                this.isShow1 = true
              }
              if (item1.name === 'role') {
                this.isShow2 = true
              }
              if (item1.name === 'account') {
                this.isShow3 = true
              }
              if (item1.name === 'push') {
                this.isShow4 = true
              }
              if (item1.name === 'log') {
                this.isShow5 = true
              }
              if (item1.name === 'openPlatform') {
                this.isShow6 = true
              }
              if (item1.name === 'opinionCollection' && (this.accountLevel == '1' || this.accountLevel == '2')) {
                this.isShow7 = true
              }
            })
          } else if (item.name === '/') {
            this.screenShow = true
          } else if (item.name === 'accountCenter') {
            this.baseShow = true
          } else if (item.name === 'message') {
            this.messShow = true
          }
        })
      })
    },
    async logout() {
      this.$confirm('确定退出系统吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$store.dispatch('LogOut').then(() => {
            location.href = '/index'
          })
        })
        .catch(() => {})
    }
  }
}
</script>

<style>
.el-dropdown-menu {
  /* z-index: 99999 !important; */
  width: 120px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
<style lang="scss" scoped>
::v-deep .el-tabs__active-bar {
  background-color: #00bfbf !important;
  width: 89px !important;
}

::v-deep .el-tabs__item:hover {
  color: #00bfbf;
}

::v-deep .el-tabs__item.is-active {
  color: #00bfbf;
}

::v-deep .el-drawer__wrapper {
  pointer-events: none;
  // display: none !important;
}

// @import '../../assets/css/drawer.scss';
::v-deep .el-dropdown-menu__item:hover {
  color: #00bfbf !important;
  background-color: #e7ffff !important;
}
::v-deep .el-dropdown-menu__item {
  padding: 0px 13px !important;
}

.el-select-dropdown__item.selected {
  color: #00bfbf !important;
}

.drawer {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 350px;
  // background-color: pink;
  z-index: 9999;

  ::v-deep .el-drawer {
    z-index: 9999;
    background-color: #fff;
    top: 62px;
  }

  ::v-deep .el-drawer.rtl {
    height: calc(100% - 62px);
  }

  .demo-drawer-content {
    pointer-events: all;
    height: 100%;
    overflow: auto;

    .point-box {
      cursor: pointer;
    }

    ::v-deep .el-tabs,
    .el-tab-pane {
      flex-direction: column;
      height: 100%;
      display: flex;
      overflow: auto;
    }

    ::v-deep .el-tabs__header {
      margin: 0;
    }

    ::v-deep .el-tabs__content {
      flex: 1;
    }

    ::v-deep .el-tabs--top .el-tabs__item.is-top:nth-child(2) {
      // padding-left: 0;
      border-right: 2px solid #cdcdcd;
      height: 12px;
      line-height: 12px;
      padding-right: 40px;
      margin: 15px 20px 20px 0;
    }

    // top: 100px;
    ::v-deep .el-tabs__nav-scroll {
      display: flex;
      justify-content: center;
    }

    .drawer-top {
      height: 37px;
      width: 100%;
      font-size: 12px;
      font-family: PingFang-SC-Regular;
      display: flex;
      align-items: center;
      justify-content: end;
      border-bottom: 1px solid #e8eaec;
      padding: 12px 20px;

      .top-l {
        margin-right: 10px;
        border-right: 2px solid #cdcdcd;
        padding-right: 10px;
        height: 10px;
        line-height: 10px;
        color: #212734;
      }

      .top-r {
        color: #00bfbf;
      }
    }

    .drawer-content {
      display: flex;
      flex-direction: column;

      .main-box {
        height: 90px;
        width: 100%;
        border-bottom: 1px solid #e8eaec;
        font-size: 12px;
        font-family: PingFang-SC-Regular;
        padding: 15px;
        display: flex;

        ::v-deep .el-badge__content.is-dot {
          height: 10px;
          width: 10px;
          margin: 5px 5px 0 0;
        }

        .main-content {
          width: 100%;
          display: flex;
          flex-direction: column;

          .main-top {
            text-align: left;
          }

          .main-bottom {
            display: flex;
            justify-content: space-between;
            margin-top: 10px;
          }
        }
      }
    }
  }
}

.navbar {
  // z-index: 99999;
  height: 60px;
  overflow: hidden;
  position: relative;
  // background: #00bfbf;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);

  .hamburger-container {
    width: 60px;
    line-height: 60px;
    height: 60px;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: #029797;
    }
  }

  .breadcrumb-container {
    float: left;
    // padding-left: 20px;
    line-height: 62px;
    font-family: MFLiHei_Noncommercial-Regular;
    font-size: 24px;
    font-weight: normal;
    // font-style: italic;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #ffffff;
  }

  .topmenu-container {
    position: absolute;
    left: 50px;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    // float: right;
    position: absolute;
    right: 0;
    top: 0;
    height: 100%;
    line-height: 60px;

    &:focus {
      outline: none;
    }

    // font-size: 14px;
    .right-menu-item {
      // z-index: 99999;
      position: relative;
      display: inline-block;
      padding: 0 10px;
      height: 100%;
      // font-size: 18px;
      color: #ffffff;
      vertical-align: text-bottom;

      ::v-deep .el-select .el-input .el-select__caret {
        color: #fff;
      }

      ::v-deep .el-input__inner {
        height: 30px;
        line-height: 30px;
        width: 150px;
        border-radius: 2px;
        color: #ffffff;
        background-color: #00bfbf;
        border: solid 1px #eeeeee;
      }

      // ::v-deep .el-dropdown-menu__item:hover {
      //   background-color: pink;
      // }

      .console-box {
        // top: 10px;
        margin-top: 20px;
        height: 24px;
        width: 40px;
        letter-spacing: 2px;
        border: 1px solid #fff;
        text-align: center;
        line-height: 22px;
        font-size: 12px;
        // padding: 3px 8px;
      }
      .console-box2 {
        margin-top: 20px;
        height: 24px;
        width: 80px;
        letter-spacing: 2px;
        border: 1px solid #fff;
        text-align: center;
        line-height: 22px;
        font-size: 12px;
      }

      .hover-effect {
        cursor: pointer;
      }

      // &.hover-effect {
      //   color: #ffffff;
      //   cursor: pointer;
      //   transition: background 0.3s;

      //   &:hover {
      //     background: rgba(0, 0, 0, 0.025);
      //   }
      // }
      ::v-deep .el-badge__content.is-fixed {
        top: 20px;
        right: 11px;
      }

      ::v-deep .el-badge__content {
        font-size: 12px;
        height: 13px;
        line-height: 13px;
        padding: 0px 5px;
        border: none;
      }

      ::v-deep .icon-xiaoxi {
        font-size: 20px;
      }
    }

    .item-screen {
      ::v-deep .el-input__inner {
        height: 30px;
        line-height: 30px;
        width: 150px;
        background-color: #263040;
        border-radius: 2px;
        border: solid 1px #aaacad;
        color: #fff;
      }
    }

    .item-help {
      // padding: 0;
      ::v-deep .el-icon-question {
        font-size: 23px;
        color: #fff;
      }
    }

    .item-bar {
      width: 2px;
      height: 14px;
      border: 0px;
      background-color: #fff;
      position: absolute;
      top: 22px;
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        margin-top: 6px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 24px;
          height: 24px;
          border-radius: 22px;
        }

        span {
          position: relative;
          top: -8px;
          right: -5px;
          font-size: 12px;
        }

        .el-icon-arrow-down {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 19px;
          font-size: 12px;
        }
      }
    }
  }
}

.navbar-screen {
  // display: flex;
  // align-items: center;
  background-image: url('../../assets/images/background-top.png');
  background-size: cover;
  background-position: center center;
  // background-color: #283240;
  text-align: center;
  // opacity: 1;
  // border: 1px solid #00bfbf;
}

::v-deep .user-info-head {
  margin-right: 65px;
}

/*闪烁动画*/
@keyframes twinkle {
  from {
    opacity: 1;
  }

  50% {
    opacity: 0.4;
  }

  to {
    opacity: 1;
  }
}

.flash ::v-deep .el-badge__content {
  animation: twinkle 2s;
  animation-iteration-count: infinite;
}
</style>
